import { RefreshCw } from "lucide-react";

export const RetryError = ({ message, onRetry, className = "" }) => (
  <div data-testid="chat-error" className={`flex flex-wrap items-center gap-3 rounded-2xl border border-rose-500/30 bg-rose-950/20 px-4 py-3 ${className}`}>
    <p className="text-sm text-rose-300 flex-1 min-w-[160px]">{message}</p>
    <button type="button" data-testid="retry-button" className="btn-ghost" onClick={onRetry}>
      <RefreshCw size={13} /> Retry
    </button>
  </div>
);
